export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9524.6658671b.jpg";